import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { useMomentumSidebar } from 'features/momentum/hooks/useSidebar';
import { ISprint, SprintsType } from 'features/sprint/config/types';

import { Button } from 'shared/components/Button';

type TMomentumOpenSidebarButton = {
  sprint: ISprint;
  sprints: SprintsType;
};

export const MomentumOpenSidebarButton = ({
  sprint,
  sprints,
}: TMomentumOpenSidebarButton) => {
  const { openSidebar } = useMomentumSidebar({
    sprint,
    sprints,
    dateRange: undefined, // No timeline context available in this component
  });

  return (
    <Button onClick={openSidebar} size="sm">
      View more <Icon name={iconNames.arrowRight} height="10px" width="6px" />
    </Button>
  );
};
